import React, { useRef } from "react";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
// import "./RaceCardPostSection.css";
const UpcomingRaceCard = () => {

  return (
    <div className="my-new-winners-main-container">
       <div className="my-new-upcoming-card-header">
        <h2>UPCOMING RACE</h2>
        
    </div>
    <div className="my-new-upcomming-race-card">
       
    </div>
    </div>
  );
};

export default UpcomingRaceCard;